import PropTypes from 'prop-types';
import InlineSpinner from '../Spinner/InlineSpinner';
import './_Button.scss';

export const Button = ({
  text,
  inverted = false,
  className,
  disabled,
  extraStyle,
  loading,
  type = 'button',
  isWorking,
  ...props
}) => (
  <button
    type={type === 'button' ? 'button' : 'submit'}
    disabled={disabled}
    className={`button-main ${className} ${
      inverted ? '' : ''
    }
    ${disabled && 'button__disabled'}
    ${extraStyle}
    `}
    {...props}
  >
    {(isWorking === 0 || !loading) ? text : <InlineSpinner />}
  </button>
);

Button.propTypes = {
  text: PropTypes.string.isRequired,
  inverted: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  extraStyle: PropTypes.string,
  loading: PropTypes.bool,
  type: PropTypes.string,
  isWorking: PropTypes.number,
};
